export enum PatientCaseStatus {
    'Newly Created' = 'In Progress',
    'Newly Submitted' = 'In Progress',
    'Pending on Consultant' = 'In Progress',
    'Accepted By Consultant' = 'In Progress',
    'Rejected By Consultant' = 'In Progress',
    'Consultant Need More Info' = 'In Progress',
    'Consultant Final Comment Submitted' = 'In Progress',
    'Closed' = 'Closed',
    'Completed' = 'Completed',
    'Pending Input' = 'Pending Input',
    'Pending Input Clinician' = 'In Progress',
    'Case Updated' = 'In Progress',
}

export enum PatientCaseStatusColors {
    'Newly Created' = '#6425D0',
    'Newly Submitted' = 'In Progress',
    'Pending on Consultant' = '#DE7802',
    'Accepted By Consultant' = '#2EA121',
    'Rejected By Consultant' = '#D83931',
    'Consultant Need More Info' = '#DC9B04',
    'Consultant Final Comment Submitted' = '#245BDB',
    'Closed' = 'Closed',
    'Completed' = 'Completed',
    'Pending Input' = 'Pending Input',
    'Case Updated' = 'In Progress',
}

export enum ConsultantCaseStatus {
    'Newly Created' = 'In Progress',
    'Newly Submitted' = 'In Progress',
    'Pending on Consultant' = 'Pending',
    'Accepted By Consultant' = 'Accepted',
    'Rejected By Consultant' = 'Rejected',
    'Consultant Need More Info' = 'Pending Input',
    'Consultant Final Comment Submitted' = 'Completed',
    'Closed' = 'Closed',
    'Completed' = 'Completed',
    'Pending Input' = 'Pending Input',
    'Case Updated' = 'Case Updated',
}